import {
  CLEAR_RESOURCE,
  FETCH_RESOURCE,
  FETCH_RESOURCES,
  FETCH_RESOURCES_FAILURE,
  FETCH_RESOURCES_SUCCESS,
  FETCH_RESOURCE_FAILURE,
  FETCH_RESOURCE_SUCCESS
} from '../mutation-types'

const mutations = {
  [FETCH_RESOURCES] (state) {
    state.loadingResources = true
    state.error = null
  },
  [FETCH_RESOURCES_SUCCESS] (state, resources) {
    state.ppe = resources.ppe
    state.detector = resources.detector
    state.decontamination = resources.decontamination
    state.sampling_type = resources.sampling_type
    state.loadingResources = false
    state.loaded = true
  },
  [FETCH_RESOURCES_FAILURE] (state, error) {
    state.resources = {}
    state.error = error
    state.loadingResources = false
  },

  [FETCH_RESOURCE] (state) {
    state.loadingResource = true
    state.error = null
  },
  [FETCH_RESOURCE_SUCCESS] (state, resource) {
    state.materialPortalResource = resource
    state.loadingResource = false
  },
  [FETCH_RESOURCE_FAILURE] (state, error) {
    state.materialPortalResource = {}
    state.error = error
    state.loadingResource = false
  },
  [CLEAR_RESOURCE] (state) {
    state.materialPortalResource = {}
  }
}

export default mutations
